export const basicContext = {
	custom: {
		dfpId: '5441',
		region: 'aw',
		property: 'tvguide',
	},
	options: {
		customAdLoader: {
			globalMethodName: 'loadCustomAd',
		},
	},
};
